import { render } from "./MainProductsWithMinimumStock.vue?vue&type=template&id=48be30ec&scoped=true"
import script from "./MainProductsWithMinimumStock.vue?vue&type=script&lang=js"
export * from "./MainProductsWithMinimumStock.vue?vue&type=script&lang=js"

import "./MainProductsWithMinimumStock.vue?vue&type=style&index=0&id=48be30ec&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48be30ec"]])

export default __exports__